import { IconButton, Stack, Tooltip } from '@mui/material';
import { Controller } from 'react-hook-form';
import { DeleteOutline } from '@mui/icons-material';
import { Column } from 'components/shared/TableListing/types';
import { InputField, ColorPickerField } from 'components/form';
import { green, grey, orange, red, yellow } from '@mui/material/colors';
import { TierEntityName, TierEntity, TierTableContext } from './types';
import { FACT_NAMES_NUMERIC } from '@trnsact/business-criteria';
import { CriteriaValue } from 'modules/jsonRulesCriterias/businessCriteria/types';

export const newTier = {
  name: 'New',
  color: 'black',
  criteria: null,
  description: '',
};

export const initialTableData: TierEntity[] = [
  { color: green['400'], name: TierEntityName.Prime },
  { color: yellow['400'], name: TierEntityName.NearPrime },
  { color: orange['400'], name: TierEntityName.MidTier },
  { color: red['400'], name: TierEntityName.Subprime },
  { color: grey['400'], name: TierEntityName.NotQualified },
].map(tier => ({ ...tier, description: '', isActive: false, criteria: null }));

export const initialColumns: Column<TierEntity, TierTableContext>[] = [
  {
    width: '4.5rem',
    header: 'Actions',
    renderKey: 'actions',
    renderCell: ({ context: { handleRemoveRow }, rowIndex }) => (
      <Tooltip title="Remove Tier">
        <IconButton
          onClick={() => {
            handleRemoveRow(rowIndex);
          }}
        >
          <DeleteOutline color="error" />
        </IconButton>
      </Tooltip>
    ),
  },
  {
    renderKey: 'name',
    header: 'Internal Tier Name',
    renderCell: ({ context: { form }, rowIndex }) => (
      <Stack direction="row" gap="1rem" width="100%" alignItems="center">
        <Controller
          control={form.control}
          name={`bodyFields.${rowIndex}.color`}
          render={({ field: { value, onChange } }) => (
            <ColorPickerField initialColor={value ?? initialTableData[rowIndex].color} onColorChanged={onChange} />
          )}
        />

        <InputField control={form.control} inputProps={{ variant: 'outlined' }} name={`bodyFields.${rowIndex}.name`} />
      </Stack>
    ),
  },
  {
    renderKey: 'description',
    header: 'Description',
    renderCell: ({ context: { form }, rowIndex }) => (
      <InputField
        control={form.control}
        name={`bodyFields.${rowIndex}.description`}
        inputProps={{ variant: 'outlined', placeholder: 'Description' }}
      />
    ),
  },
];

export const initialCriteriasValues: Record<string, Record<string, CriteriaValue>> = {
  [FACT_NAMES_NUMERIC.FICO]: {
    [TierEntityName.Prime]: {
      number: { min: '760', max: '' },
      boolean: { value: false },
      string: { value: [] },
      fact: FACT_NAMES_NUMERIC.FICO,
    },
    [TierEntityName.NearPrime]: {
      number: { min: '700', max: '759' },
      boolean: { value: false },
      string: { value: [] },
      fact: FACT_NAMES_NUMERIC.FICO,
    },
    [TierEntityName.MidTier]: {
      number: { min: '640', max: '699' },
      boolean: { value: false },
      string: { value: [] },
      fact: FACT_NAMES_NUMERIC.FICO,
    },
    [TierEntityName.Subprime]: {
      number: { min: '600', max: '639' },
      boolean: { value: false },
      string: { value: [] },
      fact: FACT_NAMES_NUMERIC.FICO,
    },
  },
};

export const initialCriterias = Object.keys(initialCriteriasValues) as FACT_NAMES_NUMERIC[];
